import EventEmitter from 'eventemitter3';
import { IShowNotificationState, MessageDialogState } from '../ts/Definitions';

export const MemberSelected = 'MemberSelected';
export const ShowHelp = 'showHelp';
export const ShowMessageDialog = 'ShowMessageDialog';
export const ShowSessionDetails = 'ShowSessionDetails';
export const ShowProfile = 'ShowProfile';
export const ShowNewItemsDialog = 'ShowNewItemsDialog';
export const ShowSettingItemEditorDialog = 'ShowSettingItemEditorDialog';
export const ShowNotification = 'ShowNotification';
export const ShowRequestPurchase = 'ShowRequestPurchase';
export const ShowRequestForItemDialog = 'ShowRequestForItemDialog';
export const ShowLovenseHelpDialog = 'ShowLovenseHelpDialog';
export const ShowLogonDialog = 'ShowLogonDialog';
export const ShowNewTaskDialog = 'ShowNewTaskDialog';
export const ShowNewItemDialog = 'ShowNewItemDialog';
export const ShowAdditionDialog = 'ShowAdditionDialog';
export const ShowPilloryDialog = 'ShowPilloryDialog';
export const ShowRewardDialog = 'ShowRewardDialog';
export const TransferOwnerDialog = 'TransferOwnerDialog';
export const LoanMemberDialog = 'LoanMemberDialog';
export const ShareMemberDialog = 'ShareMemberDialog';
export const ShowRequestProof = 'ShowRequestProof';
export const ShowConfirmDialog = 'ShowConfirmDialog';
export const ShowChangeScheduledTask = 'ShowChangeScheduledTask';
export const ShowTodoDialog = 'ShowTodoDialog';
export const ShowOptionsDialog = 'ShowOptionsDialog';
export const ShowRestoreSettingsDialog = 'ShowRestoreSettingsDialog';
export const ShowTourDialog = 'ShowTourDialog';
export const ShowQRCodeExplain = 'ShowQRCodeExplain';
export const ShowTestRunDialog = 'ShowTestRunDialog';
export const ShowOptionPickerDialog = 'ShowOptionPickerDialog';
export const ShowImportImageDbDialog = 'ShowImportImageDbDialog';

export const ValidateAndSaveEditItem = 'ValidateAndSaveEditItem';
export const DATABASE_OFFLINE = 'DATABASE_OFFLINE';
export const DATABASE_ONLINE = 'DATABASE_ONLINE';
export const DATABASE_CONNECTING = 'DATABASE_CONNECTING';

export const DATABASE_CHECK_SAVING = 'DATABASE_SAVING';
export const DATABASE_SAVE_PENDING = 'DATABASE_SAVE_PENDING';
export const DATABASE_SAVE_COMPLETE = 'DATABASE_SAVE_COMPLETE';

export const NOTIFY_PAGE_UPDATES = 'NOTIFY_PAGE_UPDATES';
export const DISABLE_INSTALLER = 'DISABLE_INSTALLER';
export const INSTALL = 'INSTALL';

export const POSITION_TIMER_COMPLETE = 'POSITION_TIMER_COMPLETE';
export const METRONOME_TIMER_COMPLETE = 'METRONOME_TIMER_COMPLETE';
export const SITE_EFFECTS_TIMER_COMPLETE = 'SITE_EFFECTS_TIMER_COMPLETE';
export const ShowMetronomeDialog = 'ShowMetronomeDialog';
export const ShowSiteEffectsOverlay = 'ShowSiteEffectsOverlay';
export const ShowOutfitRatingDialog = 'ShowOutfitRatingDialog';


const eventEmitter = new EventEmitter();

const Emitter = {
    on: (event: string, fn: (a1: any, a2?: any, a3?: any, a4?: any, a5?: any) => void): EventEmitter<string | symbol, any> => eventEmitter.on(event, fn),
    once: (event: string, fn: (a1: any, a2?: any, a3?: any, a4?: any, a5?: any) => void): EventEmitter<string | symbol, any> => eventEmitter.once(event, fn),
    off: (event: string, fn: (a1: any, a2?: any, a3?: any, a4?: any, a5?: any) => void): EventEmitter<string | symbol, any> => eventEmitter.off(event, fn),
    emit: (event: string, ...payload: any[]): boolean => eventEmitter.emit(event, ...payload),
    emitMessage: (payload: MessageDialogState | undefined): boolean => eventEmitter.emit(ShowMessageDialog, payload),
    emitNotification: (payload: IShowNotificationState): boolean => eventEmitter.emit(ShowNotification, payload),
};

Object.freeze(Emitter);

export default Emitter;